import { useMutation } from "@tanstack/react-query";
import { api } from "../client";
import type { LoginCheckPostRequest } from "../../generated/fresh-guard-api";

export function useLoginCheck() {
  return useMutation({
    mutationFn: async (input: LoginCheckPostRequest) => {
      const res = await api.loginCheckApi.loginCheckPost(input);
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
